module.exports = __webpack_public_path__ + "static/media/jjrhatigan.c6cd1d85.png";